/* unplugin-vue-components disabled */import { render } from "./SAlbum.vue?vue&type=template&id=71837e11&scoped=true&ts=true"
import script from "./SAlbum.vue?vue&type=script&lang=ts"
export * from "./SAlbum.vue?vue&type=script&lang=ts"

import "./SAlbum.vue?vue&type=style&index=0&id=71837e11&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71837e11"],['__file',"src/views/searchContent/cpns/SAlbum.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71837e11"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71837e11', __exports__)) {
    console.log('reload')
    api.reload('71837e11', __exports__)
  }
  
  module.hot.accept("./SAlbum.vue?vue&type=template&id=71837e11&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('71837e11', render)
  })

}


export default __exports__